/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select priority (1-10)" |
*
* @param {Explorer_Info_Priority_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_placeholder = /** @type {((inputs?: Explorer_Info_Priority_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Select priority (1-10)")
	return /** @type {LocalizedString} */ ("Select priority (1-10)")
});